
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

// Icons
import LockIcon from '@mui/icons-material/Lock';

const DialogInfoDeactivated: FC = () => {

  const { t } = useTranslation();

  return (
    <Tooltip
      title={t('messages.deactivated_record_tooltip')}
      placement="top"
    >
      <Box sx={{ pl: 1 }} display="flex" alignItems="center">
        <LockIcon sx={{ color: 'primary.main' }} />
        <Box ml={1} color="primary.main" alignSelf="flex-end">
          {t('messages.deactivated_record')}
        </Box>
      </Box>
    </Tooltip>)
};

export default DialogInfoDeactivated;